export const achievementStats = [
  { value: '100%', label: 'Grade 10 pass rate, three years running' },
  { value: '82%', label: 'of leavers reach their first-choice school' },
  { value: '2 yrs', label: 'average reading age gain in Primary 1–3' },
  { value: '94%', label: 'of pupils stay from Grade 1 to Grade 10' },
];

export const honours = [
  {
    year: '2026',
    title: 'Second place, Lagos State Science Fair',
    detail: 'Grade 9 · low-cost clay and rice-husk water filter',
    tag: 'State level',
  },
  {
    year: '2025',
    title: 'Ikeja Zone reading championship, winners',
    detail: 'Primary 4 and 5 · four schools, 60 readers',
    tag: 'Zonal',
  },
  {
    year: '2025',
    title: 'State commendation for pupil retention',
    detail:
      'Highest Grade 1 to Grade 10 continuity of any public school in the zone',
    tag: 'State level',
  },
  {
    year: '2024',
    title: 'Mr. Bello Yusuf — Zone Teacher of the Year',
    detail: 'Twelve years teaching Primary mathematics at the Academy',
    tag: 'Staff',
  },
  {
    year: '2024',
    title: 'Under-13 football, zone runners-up',
    detail: "First final in the school's history",
    tag: 'Sport',
  },
];
